export default "__VITE_ASSET__eyUs$Xla__"